export var DEPLOY_DATE = new Date('2025-10-28T20:08:29+0000');
